// extracted by mini-css-extract-plugin
export default {"shop":"Shop_shop__s3+fr","container":"Shop_container__Rufq5","sort":"Shop_sort__9Lrn8","list":"Shop_list__tIUso","pagination":"Shop_pagination__HNOm1"};